import React, { useEffect, useCallback, useState} from 'react';
import {setWorksLoaded} from 'actions/index.js';
import {connect} from 'react-redux';

const CombineButton = ({
    setWorksLoaded,
    multiSequencerEngine,
    sequencerEngine,
    worksLoaded
}) => { 

    let combine = useCallback(() => {
        // combine the sequences that are not sequencerEgine
        // into sequenceREngine and then destroy the other ones
        let engines = Object.values(multiSequencerEngine.idToSequencerEngine).filter(
            e => e !== sequencerEngine);
        engines.forEach(
            engine => sequencerEngine.subSequences =
                [... sequencerEngine.subSequences, ... engine.subSequences]);
        engines.forEach(
            engine => multiSequencerEngine.unloadTrack(
                engine.getSequenceId(), false));
        let _worksLoaded = worksLoaded.filter(
            x => x.newSequence === sequencerEngine.getSequenceId());
        setWorksLoaded(_worksLoaded);
    }, [worksLoaded, sequencerEngine]);

    if (worksLoaded && worksLoaded.length > 1) {
        return (
            <div
              onClick={combine}
              className="combine-works-button">
              Combine Projects
            </div>
        );
    }
    return '';
}

const mapStateToProps = (state, props) => {
  return {
      worksLoaded: state.explore.worksLoaded
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setWorksLoaded: (x) => dispatch(setWorksLoaded(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CombineButton);
